var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeeding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 359"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.6372 16.5437L26.7713 15.4017C27.2021 14.9688 27.9007 14.9688 28.3316 15.4017M32.2687 23.2068L33.4027 22.0648C33.8336 21.6319 33.8336 20.93 33.4027 20.497L28.3316 15.4017M28.3316 15.4017C28.3316 15.4017 30.2332 13.4911 32.2645 14.7817C32.2645 14.7817 33.4514 13.2952 34.5729 14.422C35.6944 15.5489 34.2526 16.7036 34.2526 16.7036C35.3531 18.7334 33.5002 20.5952 33.5002 20.5952M15.215 25.9355L17.5653 28.3014M18.1406 22.9958L20.4909 25.3618M21.0662 20.0562L23.4165 22.4221M13.6059 27.4542L22.6754 18.3414C23.4833 17.5297 24.7932 17.5297 25.6011 18.3414L30.5746 23.3388C31.3825 24.1505 31.3825 25.4666 30.5746 26.2784L21.5052 35.3912C20.6973 36.2029 19.3874 36.2029 18.5795 35.3912L13.6059 30.3938C12.798 29.5821 12.798 28.266 13.6059 27.4542Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeding);
export default __webpack_public_path__ + "static/media/feeding.c0233d300f3dbc0c880033b93e89a48b.svg";
export { ForwardRef as ReactComponent };